import { useEffect, useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import Swal from "sweetalert2";
import { decryptData, defaulUrl, impression } from "../components/const";
import AddUser from "../Authentification/AddUser";
import $ from "jquery"
import ModalSendSms from "../CompteAgent/ModalSendSms";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ListePers = () => {
    const { data: personnel, isloading } = UseFetch('personnel');
    const [loading, setLoading] = useState(false)
    const tableRef = useRef()
    const printElement = useRef()

    const handleAction = (action, pers, status) => {
        Swal.fire({
            title: 'Gestion personnel',
            text: `Voulez-vous ${action} cet travailleur?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'OUI',
            cancelButtonText: 'Annuler'
        }).then(confim => {
            if (confim.isConfirmed) {
                pers.status = status;
                pers.statut = status !== 'En fonction' ? 'Bloqué' : 'Actif';
                let statuCode = 0;
                setLoading(true)

                let formData = new FormData()
                for (var key in pers) {
                    formData.append(key, pers[key]);
                }

                fetch(`${defaulUrl}personnel-saction/${pers.id}`, {
                    method: "POST",
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
                    },
                    body: formData
                }).then(response => {
                    statuCode = response.status
                    return response.json()
                }).then(data => {
                    setLoading(false)
                    Swal.fire({
                        title: statuCode === 200 ? "Succès" : "Erreur",
                        text: data.message,
                        icon: statuCode === 200 ? 'success' : 'error'
                    })
                })
            }
        })
    }

    // Préparer la liste pour envoi de SMS
    const clients = personnel?.map(p => ({
        client: `${p.firstname} ${p.lastname}`,
        telephone: p.phone
    }));

    $(tableRef.current).DataTable();

    // 🔹 Fonction PDF dynamique pour le personnel
    const printPersonnel = (title, tab = []) => {
        const user = decryptData("USER");

        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");

        // Entête PDF
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes visibles dans le tableau HTML
        const headers = [
            "N°",
            "PRENOMS & NOM",
            "TELEPHONE",
            "EMAIL",
            "FONCTION",
            "MAGASIN",
            "STATUT"
        ];

        const data = tab.map((pers, index) => [
            index + 1,
            (pers.firstname + ' ' + pers.lastname)?.toUpperCase() || "",
            pers.phone || "",
            pers.email || "",
            pers.droit === 'Magasin' ? 'Vendeur' : pers.droit || "",
            pers.magasin?.magasin?.toUpperCase() || "",
            pers.status || ""
        ]);

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title || "personnel"}.pdf`);
    }

    return (
        isloading ? <div className="loader"></div> :
            <div className="mt-3">
                {loading && <div className="loader"></div>}

                <div className="row justify-content-end">
                    <button className='btn btn-primary w-auto m-1' data-bs-toggle="modal" data-bs-target="#modal-envoi">Envoyer message</button>
                    <button className='btn btn-primary w-auto m-1' data-bs-toggle="modal" data-bs-target="#modalUser">Nouveau travailleur</button>
                </div>

                <button className="btn btn-primary m-1 w-auto ms-auto" onClick={() => printPersonnel("Liste du personnel", personnel)}>
                    <i className="bx bx-printer"></i>
                </button>

                <div className="table-responsive" ref={printElement}>
                    <table ref={tableRef} className="table table-striped table-bordered table-hover">
                        <thead className="table-dark">
                            <tr className="align-middle text-center">
                                <th>N°</th>
                                <th>PRENOMS & NOM</th>
                                <th>TELEPHONE</th>
                                <th>EMAIL</th>
                                <th>FONCTION</th>
                                <th>MAGASIN</th>
                                <th>STATUT</th>
                                <th className="text-end">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody className="plage">
                            {personnel?.map((pers, ind) => (
                                <tr className="align-middle tr" key={ind}>
                                    <td>{ind + 1}</td>
                                    <td>{(pers.firstname + ' ' + pers.lastname)?.toUpperCase()}</td>
                                    <td>{pers.phone}</td>
                                    <td>{pers.email}</td>
                                    <td>{pers.droit === 'Magasin' ? 'Vendeur' : pers.droit}</td>
                                    <td>{pers.magasin?.magasin?.toUpperCase()}</td>
                                    <td>{pers.status}</td>
                                    <td className="text-end">
                                        <a className="dropdown-toggle dropdown-toggle-nocaret" href="#" data-bs-toggle="dropdown">
                                            <i className='bx bx-dots-vertical-rounded font-22 text-option px-2 bg-primary-subtle shadow rounded-circle'></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <div className="row row-cols-2 g-1 p-1">
                                                <div className="col text-center">
                                                    <button className="btn btn-danger mx-auto"
                                                        disabled={pers.status !== 'En fonction'}
                                                        onClick={() => handleAction('Sactionner', pers, 'Sanctionné(e)')}>
                                                        <i className='bx bx-atom'></i>
                                                    </button>
                                                    <div className="app-title">Sanctionner</div>
                                                </div>
                                                <div className="col text-center">
                                                    <button className="btn btn-success mx-auto"
                                                        disabled={pers.status !== 'Sanctionné(e)'}
                                                        onClick={() => handleAction('Lever la sanction de', pers, 'En fonction')}>
                                                        <i className='bx bx-shield'></i>
                                                    </button>
                                                    <div className="app-title">Lever la sanction</div>
                                                </div>
                                                <div className="col text-center">
                                                    <button className="btn btn-danger mx-auto"
                                                        disabled={pers.status === 'Licencié(e)'}
                                                        onClick={() => handleAction('Licencier', pers, 'Licencié(e)')}>
                                                        <i className='bx bx-no-entry'></i>
                                                    </button>
                                                    <div className="app-title">Licencier</div>
                                                </div>
                                                <div className="col text-center">
                                                    <button className="btn btn-success mx-auto"
                                                        disabled={pers.status !== 'Licencié(e)'}
                                                        onClick={() => handleAction('Reprendre', pers, 'En fonction')}>
                                                        <i className='bx bx-notification'></i>
                                                    </button>
                                                    <div className="app-title">Reprendre</div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <AddUser isuser={0} />
                <ModalSendSms clients={clients} />
            </div>
    );
}

export default ListePers;
